'use client';

import { useCallback, useState } from 'react';

type Props = {
  value: boolean;
  onTrue: () => void;
  onFalse: () => void;
  onToggle: () => void;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
};

function useBoolean(defaultValue?: boolean): Props {
  const [value, setValue] = useState(
    defaultValue !== undefined ? defaultValue : false,
  );

  const onTrue = useCallback(() => {
    setValue(true);
  }, []);

  const onFalse = useCallback(() => {
    setValue(false);
  }, []);

  const onToggle = useCallback(() => {
    setValue(prev => !prev);
  }, []);

  return {
    value,
    onTrue,
    onFalse,
    onToggle,
    setValue,
  };
}

export default useBoolean;
